import { Navbar, Page } from "framework7-react";
import { useEffect } from "react";

import { NavLeftEmpty } from "@/components/NavLeftEmpty";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { SettingList } from "@/components/SettingList";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { useGetVersion } from "@/generated/api";
import { usePageReady } from "@/hooks/usePageReady";
import { useVisibilityChange } from "@/hooks/useVisibilityChange";
import { useVersionStore } from "@/stores/versionStore";

export const SettingListPage = createPage("SettingsPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { isPageReady, getPageProps } = usePageReady(pageName, { isTabPage: true });
  const { documentVisible } = useVisibilityChange();
  const { data, refetch } = useGetVersion();
  const { setServerVersion } = useVersionStore();

  useEffect(() => {
    if (documentVisible || isPageReady) {
      void refetch();
    }
  }, [documentVisible, refetch, isPageReady]);

  useEffect(() => {
    if (data) {
      const appVersion = data.data.version;
      setServerVersion(appVersion);
    }
  }, [data, setServerVersion]);

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftEmpty />
        <NavTitle>設定</NavTitle>
        <NavRightEmpty />
      </Navbar>
      <SettingList />
    </Page>
  );
}
